import { ChangeDetectionStrategy, Component, computed, effect, Signal, signal, untracked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReportParameterBase } from './report-parameter-base';
import { ProductCategoryCostSelectComponent } from '../../../costing';

@Component({
    selector: 'app-product-category-cost-select-parameter',
    imports: [ProductCategoryCostSelectComponent],
    template: `
        <app-product-category-cost-select
            [selectedProductCategoryCostKey]="productCategoryCostKey()"
            [id]="parameterDefinition().key"
            [subscriberKey]="subscriberKey()"
            [placeHolder]="subscriberKey() != null ? parameterDefinition().placeholder : 'Select a subscriber first'"
            [invalid]="isInvalid()"
            [disabled]="isDisabled()"
            (blur)="onBlur()"
            (loadingChange)="onLoadingChange($event)"
            (selectedProductCategoryCostKeyChange)="onSelectedProductCategoryCostKeyChange($event ?? null)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ProductCategoryCostSelectParameterComponent,
            multi: true
        }
    ]
})
export class ProductCategoryCostSelectParameterComponent extends ReportParameterBase<number | null> {
    productCategoryCostKey = signal<number | null>(null);
    subscriberKey: Signal<number | null> = this.reportWorkspace.subscriberKey;

    override isDisabled = computed(() => this.reportWorkspace.isReportRunning() || this.isFormControlDisabled() || !this.subscriberKey());

    constructor() {
        super();

        /* Clear Options when Subscriber Changes */
        effect(() => {
            this.subscriberKey();
            const parameterDefinition = untracked(this.parameterDefinition);

            if (!this.isInitialized) {
                return;
            }

            const value = (parameterDefinition.emptyValue as number | null) ?? null;

            this.productCategoryCostKey.set(value);
            this.reportWorkspace.setParam(parameterDefinition.key, value);
            this.onChange(value);

            this.formControl?.markAsUntouched();
            this.formControl?.markAsPristine();
        });
    }

    onSelectedProductCategoryCostKeyChange(productCategoryCostKey: number | null) {
        this.productCategoryCostKey.set(productCategoryCostKey);

        this.reportWorkspace.setParam(this.parameterDefinition().key, productCategoryCostKey);

        this.onChange(productCategoryCostKey);
        this.markTouchedIfNotResetting();
    }

    onLoadingChange(loading: boolean) {
        this.reportWorkspace.setParamLoading(this.parameterDefinition().key, loading);
    }

    onBlur() {
        this.onTouched();
    }

    // CVA callbacks
    writeValue(obj: number | null): void {
        this.productCategoryCostKey.set(obj);
    }
}
